import { useEffect } from 'react';

import {
  clearHiddenForLogout,
  isHiddenForLogout,
} from './decagonLogoutVisibility';
import { refreshAdaTokenFromStorage } from './useAdaChatbot';

export {
  hideDecagonForLogout,
  restoreChatAfterLogout,
} from './decagonLogoutVisibility';

const swallowAdaError = (error: Error) => {
  if (error.name !== 'AdaEmbedError') {
    throw error;
  }
};

export const hideChat = () => {
  // The newest hide owns visibility; its paired showChat restores Decagon.
  clearHiddenForLogout();
  if (globalThis.adaEmbed) {
    Promise.resolve(globalThis.adaEmbed.stop()).catch(swallowAdaError);
  }
  globalThis.duet?.hide?.();
  globalThis.duet?.close?.();
};

export const showChat = () => {
  if (globalThis.adaEmbed) {
    refreshAdaTokenFromStorage();
    Promise.resolve(globalThis.adaEmbed.start(globalThis.adaSettings)).catch(
      swallowAdaError,
    );
  }
  // A logout hide outlives the modals and `useHideChat` callers that unmount
  // or mount closed around it; only a successful re-auth may undo it.
  if (isHiddenForLogout()) return;
  globalThis.duet?.unhide?.();
};

/**
 * Hides the chat launcher for the lifetime of the calling component and
 * restores it on unmount. Used on flows where the fixed-position launcher
 * overlays critical controls -- e.g. the mobile verification upload/submit
 * button, which the launcher covered on small viewports (ECDEX-2707).
 */
export const useHideChat = () => {
  useEffect(() => {
    hideChat();
    return showChat;
  }, []);
};
